var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.10805 5.64824C2.5 6.93577 2.5 8.77405 2.5 12C2.5 15.7497 2.5 17.6246 3.45491 18.9389C3.76331 19.3634 4.1366 19.7367 4.56107 20.0451C5.8754 21 7.75027 21 11.5 21H13.5C17.2497 21 19.1246 21 20.4389 20.0451C20.8634 19.7367 21.2367 19.3634 21.5451 18.9389C22.5 17.6246 22.5 15.7497 22.5 12C22.5 8.75125 22.5 6.90985 21.879 5.62103M3.10805 5.64824C3.20677 5.4392 3.32153 5.24467 3.45491 5.06107C3.76331 4.6366 4.1366 4.26331 4.56107 3.95491C5.8754 3 7.75027 3 11.5 3H13.5C17.2497 3 19.1246 3 20.4389 3.95491C20.8634 4.26331 21.2367 4.6366 21.5451 5.06107C21.6727 5.23667 21.7832 5.42228 21.879 5.62103M3.10805 5.64824L3.5 6L5.42893 7.92893C8.76227 11.2623 10.4289 12.9289 12.5 12.9289C14.5711 12.9289 16.2377 11.2623 19.5711 7.92894L21.5 6L21.879 5.62103",
    stroke: "#04D9FF",
    strokeWidth: 1.5
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.3002c73dd11662431cc3a4265c4e74cb.svg";
export { ForwardRef as ReactComponent };